import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Collection from '../components/Collection';
import About from '../components/About';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';

export default function HomePage() {
  return (
    <main>
      <Hero />
      <Features />
      <Collection />
      <About />
      <FAQ />
      <Contact />
    </main>
  );
}
